import { usePrefetchedSuspenseQuery } from "@-/com.npmjs.tanstack__react-query";
import { useHskVersionStatsQueryOptions } from "#use-hsk-version-stats-query-options";

/**
 * Every HSK version's stats. The HSK version settings navigator prefetches them, so this is a
 * cache hit under the page's suspense boundary.
 */
export function useHskVersionStatsSuspense() {
  return usePrefetchedSuspenseQuery(useHskVersionStatsQueryOptions()).data;
}
